import { useState } from 'react';
import { useKeyboard } from './useKeyboard';
import { formatMoney } from '@dastarhan/core';
import { readScale } from '../print';

/** Весовая позиция: кг руками или кнопкой «С весов» (через агента). */
export function WeightDialog({ name, unitPrice, unit, onConfirm, onCancel }: {
  name: string;
  unitPrice: number;
  unit: 'KG' | 'L';
  onConfirm: (qty: number) => void;
  onCancel: () => void;
}) {
  const [raw, setRaw] = useState('');
  // Суммы на планшете набирают своей клавиатурой: системная
  // либо не всплывает, либо закрывает половину экрана
  const kb = useKeyboard(raw, setRaw, 'number');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const qty = Number(raw.replace(',', '.'));
  const valid = Number.isFinite(qty) && qty > 0 && qty <= 1000;
  const u = unit === 'KG' ? 'кг' : 'л';

  return (
    <div className="dialog-backdrop" role="dialog" aria-modal="true" aria-label="Вес">
      <div className="dialog" style={{ maxWidth: 340, width: '100%' }}>
        <span className="eyebrow">{name}</span>
        <h1>Сколько {u}?</h1>
        <input className="field" style={{ width: '100%', fontSize: 24, textAlign: 'center' }}
          {...kb.props}
          inputMode="decimal" autoFocus placeholder={`0.000 ${u}`}
          value={raw} onChange={(e) => setRaw(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && valid && onConfirm(+qty.toFixed(3))} />
        <button className="btn" style={{ width: '100%' }} disabled={busy}
          onClick={async () => {
            setBusy(true); setErr('');
            const kg = await readScale();
            setBusy(false);
            if (kg === null) setErr('Весы не ответили — проверьте агента (⚙).');
            else setRaw(kg.toFixed(3));
          }}>
          {busy ? 'Спрашиваем весы…' : '⚖ С весов'}
        </button>
        {valid && (
          <p className="hint" style={{ margin: 0 }}>
            = <b className="money">{formatMoney(Math.round(qty * unitPrice))}</b>
          </p>
        )}
        <div className="quick" style={{ width: '100%' }}>
          {[0.3, 0.5, 1].map((q) => (
            <button key={q} className="btn small" onClick={() => setRaw(q.toFixed(1))}>
              {q} кг
            </button>
          ))}
        </div>
        <p className="error">{err}</p>
        <div className="dialog-actions" style={{ width: '100%' }}>
          <button className="btn ghost" onClick={onCancel}>Отмена</button>
          <button className="btn accent" disabled={!valid}
            onClick={() => onConfirm(+qty.toFixed(3))}>Добавить</button>
        </div>
      </div>
      {kb.node}
    </div>
  );
}
